/**
 * 存储到本地，注意控制体积
 */

import {post, get} from '../utils/http';
import Trip from '../models/Trip';
import City from '../models/City';
import isOnLine from '../native/isOnLine';
import * as storage from '../native/storage';
import {supportNative} from '../native/util';



// 离线的本地行程库
const localDB = {
  getKey(trip_id) {
    return `trip-${trip_id}`;
  },

  get(trip_id) {
    let key = this.getKey(trip_id);
    return storage.getItem(key);
  },
  set(trip_id, trip) {
    let key = this.getKey(trip_id);
    return storage.setItem(key, trip);
  },
  del(trip_id) {
    let key = this.getKey(trip_id);
    return storage.removeItem(key);
  }
};


// 保存（修改）行程 https://doc.oschina.net/xingchengzushou?t=148946
export function saveOne(trip_id, trip, itinerary_id) {
  let url = '/m/v2/?m=api/trip/sync/put';

  // 更新localDB数据
  supportNative() && localDB.set(trip_id, trip);

  trip = {
    ...trip,
  };
  delete trip.poi_uid_map;
  delete trip.city_info_maps;

  return post(url, {
    data: {
      include_city_update: 1,
      is_published: 1,
      trip_id,
      trip: JSON.stringify(trip),
      insert_itinerary_id: itinerary_id
    }
  });
}


// 删除行程 http://doc.oschina.net/xingchengzushou?t=196426
export function deleteOne(id) {
  let url = '/m/v2/?m=api/trip/edit/delete';
  // 不知道为啥搞成这样的接口
  let key = `trip_id[${id}]`;
  let data = {};
  data[key] = parseInt(Date.now() / 1000, 10) + '';

  // 删除localDB数据
  supportNative() && localDB.del(id);

  return post(url, {
    data: data
  })
    .then(function () {
    // 返回删除的ID
      return id;
    });
}


// https://doc.oschina.net/xingchengzushou?t=174990
// 获取一个Demo行程。虽然接口返回是多个Demo行程，但需求不需要
export function getOneDemo() {
  let url = '/m/v2/?m=api/trip/demo_list';

  return post(url)
    .then(function (data) {
      data = data.list;

      if (data.length) {
        return Trip.parseInput3(data[0]);
      } else {
        return null;
      }
    });
}

// https://doc.oschina.net/xingchengzushou?t=145627
//http://120.78.81.197:8181/docs/trip_v1_2/22
export function getOne(trip_id,itinerary_id) {
  let url = '/m/v2/?m=api/trip/get_trip';

  if (isOnLine()) {
    return get(url, {
      data: {
        trip_id,
        need_append: 1,
        insert_itinerary_id: itinerary_id,
      }
    })
      .then(function (data) {
        let trip = Trip.parseInput4(data.trip_info);

        supportNative() && localDB.set(trip_id, trip);

        return trip;
      });
  } else if (supportNative()) {
    return localDB.get(trip_id);
  } else {
    return Promise.reject(new Error('网络错误：10001'));
  }
}

// http://doc.oschina.net/xingchengzushou?t=218683
export function getList(page_param) {
  let url = '/m/v2/?m=api/trip/get_trip_simple_list';

  return get(url, {
    data: {page_param}
  })
    .then(function (data) {
      let city_info_map = data.city_info_map;
      let result = {
        next_page: data.next_page,
        list: data.list ? data.list.sort((a,b)=>{
          return a.update_time < b.update_time;
        }).map(function (trip) {
          return Trip.parseInput(trip, city_info_map);
        }) : []
      };
   
      return result;
    });
}


// https://doc.oschina.net/xingchengzushou?t=244704
export function createOne(params) {
  let url = '/m/v2/?m=api/trip/create_by_cma';

  // 转换数据
  if (typeof params.city_day_list === 'object') {
    params = {...params};
    params.city_day_list = params.city_day_list.map(function (item) {
      return {
        city_id: item.city,
        day: item.day
      };
    });
    params.city_day_list = JSON.stringify(params.city_day_list);
  }

  return post(url, {
    data: params
  })
    .then(function (data) {
    // 返回行程ID
      return data.trip_id;
    });
}






/**
 * 行程天数分配
 * @param {*} tripParams
 */
export function cityDayAssign(tripParams) {
  let url = '/m/v2/?m=api/trip/cma/assign';
  // 转换适配接口（fuck）
  tripParams.city_day_list = tripParams.city_day_list.map(function (item) {
    return {city_id: item.city};
  });
  tripParams.city_day_list = JSON.stringify(tripParams.city_day_list);

  return post(url, {
    data: tripParams
  })
    .then(function (data) {
      let result = [];
      let city_info_map = data.city_info_map;
      data.assign.city_day_list.forEach(function (item) {
        let city_id = item.city_id;
        let day = item.day;
        let obj = City.parseInput4({ ...city_info_map[city_id], day});
        result.push(obj);
      });

      return {
        ...data.assign,
        city_day_list: result
      };
    });
}




/**
 * 智能优化当天
 * @param {*} trip_id
 * @param {*} start_poi_uid
 * @param {*} attr_poi_uids
 * @param {*} end_poi_uid
 */
export function tripOptimizeOneDay(trip_id, start_poi_uid, attr_poi_uids, end_poi_uid) {
  let url = '/m/v2/?m=api/trip/optimize/one_day';

  return post(url, {
    data: {
      trip_id,
      start_poi_uid,
      attr_poi_uids,
      end_poi_uid
    }
  }).then(function (data) {
    return data;
  });
}


/**
 * 智能优化全程
 * @param {*} trip_id
 * @param {*} poi_list
 * @param {*} start_time
 * @param {*} end_time
 * @param {*} trip_days
 */
export function tripOptimizeAllDay(trip_id, poi_list, start_time, end_time, trip_days) {
  // flag修正，每天最后一个H为hotel，其余的H为poi
  poi_list.forEach(day => {
    let lastIndex = day.pois.length - 1;

    day.pois.forEach((poi, index) => {
      if (poi.flag === 'hotel' && index !== lastIndex) {
        poi.flag = 'poi';
      }
    });
  });

  let url = '/m/v2/?m=api/trip/optimize/all_day';

  return post(url,{
    contentType: 'application/x-www-form-urlencoded',
    processData: true,
    data: {
      trip_id,
      start_time,
      end_time,
      trip_days,
      poi_list: JSON.stringify(poi_list)
    },
    timeout: 30000
  });
}



/**
 * 获取行程的设置信息
 */
export function getTripSettingsInfo(trip_id) {
  return post('/m/v2/?m=api/trip/settings/info', {
    data: {trip_id}
  });
}



/**
* 修改行程的设置信息
*/
export function updateTripSettingsInfo(trip_id, params) {
  return post('/m/v2/?m=api/trip/settings/update', {
    data: {trip_id, ...params}
  });
}





/**
 * 创建流程中 城市线路智能优化
 * @param {*} city_day_list 
 * @param {*} start_index 
 * @param {*} end_index 
 * @param {*} start_date 
 * @param {*} start_date 
 */
export function tripCityOptimize(query) {
  let url = '/m/v2/?m=api/trip/cma/optimize';

  return post(url, {
    data: {...query}
  }).then(function (data) {
    return data;
  });
}



/**
 * 行程同步的改变事件,轮询接口
 * @param {*} query 
 */
export function getChangeEvent(query) {
  let url = '/m/v2/?m=api/trip/sync/change_event';
  
  return post(url);
}



// WEBPACK FOOTER //
// ./src/services/trip.js